import { Injectable } from '@angular/core';
import {HttpClientModule,  HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageService } from '../../shared/services/storage.service';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import {  HttpHeaders } from '@angular/common/http';
import { isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';
@Injectable({ providedIn: 'root' })
export class identityService {
  public Authenticated: boolean = false;
  public currentUser: any;
  private currentUserSubject = new Subject<any>();
  public authenticationChallenge$: Observable<any> = this.currentUserSubject.asObservable();
  public apiUrl = 'https://api-adresse.data.gouv.fr/search/';

  constructor(@Inject(PLATFORM_ID) private platformId: Object,private http: HttpClient,
  private router: Router,
   private storageService: StorageService) {
    let token = storageService.retrieve('user_token');
    if (token) this.currentUser = this.getDataFromToken(token);
    if (this.currentUser && this.Authenticated == false) { 
      this.Authenticated = true; 
      this.currentUserSubject.next(this.currentUser); 
    }
  }


  registerWithFormData(formData: FormData): Observable<any> {
  const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
  return this.http.post<any>(
    `${apiUrl}/Auth/SaveInscriptionClient`, 
    formData
  );
}
register(user: any): Observable<any> {
  const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
  const url = `${apiUrl}/Auth/SaveInscriptionClient`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  return this.http.post<any>(url, user).pipe(
    map(token => {
      const access_token = token.access_token;
      this.currentUser = this.getDataFromToken(access_token);
      this.Authenticated = true;
      this.currentUserSubject.next(this.currentUser);

      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('user_token', token["access_token"]);
        localStorage.setItem('user_id', this.currentUser.idCustomer);
      }

       return this.currentUser;
    }),
    catchError(err => {
      console.error('Erreur lors de la requête register() :', err);
      let errorMessage = 'Erreur inconnue. Réessaie plus tard.';
      if (err instanceof ProgressEvent) {
        errorMessage = 'Impossible de contacter le serveur. Vérifie ta connexion internet ou le CORS.';
      } else if (err.error && typeof err.error === 'string') {
        errorMessage = err.error;
      } else if (err.error && err.error.message) {
        errorMessage = err.error.message;
      } else if (err.status) {
        errorMessage = `Erreur serveur (${err.status})`;
      }
      return throwError(() => new Error(errorMessage));
    })
  );
}
  registerOld(user: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
  return this.http.post<any>(`${apiUrl}/Auth/Account`, user, {headers}).pipe(
    map(token => {
      const access_token = token.access_token;
      this.currentUser = this.getDataFromToken(access_token);
      this.Authenticated = true;
      this.currentUserSubject.next(this.currentUser);

      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('user_token', token["access_token"]);
        localStorage.setItem('user_id', this.currentUser.idCustomer);
      }

      return this.currentUser;
    }),
    catchError(err => {
      console.error('Erreur lors de la requête register() :', err);

      let errorMessage = 'Erreur inconnue. Réessaie plus tard.';

      if (err instanceof ProgressEvent) {
        errorMessage = 'Impossible de contacter le serveur. Vérifie ta connexion internet ou le CORS.';
      } else if (err.error && typeof err.error === 'string') {
        errorMessage = err.error;
      } else if (err.error && err.error.message) {
        errorMessage = err.error.message;
      } else if (err.status) {
        errorMessage = `Erreur serveur (${err.status})`;
      }
      return throwError(() => new Error(errorMessage));
    })
  );
}
  getAddressDetails(query: string) {
    if (!query.trim()) {
      throw new Error('Query cannot be empty');
    }
    const params = new HttpParams().set('q', query);
    return this.http.get<any>(this.apiUrl, { params });
  }
  resetPassword(resetPasswordWithReCoaptch:any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Auth/ResetPasswordRequest`;
    return this.http.post<any>(url, resetPasswordWithReCoaptch, { withCredentials: true });
  }
  ResetPasswordRequestWithCode(resetPasswordWithCode:any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Auth/ResetPasswordRequestWithCode`;
    return this.http.post<any>(url, resetPasswordWithCode, { withCredentials: true });
  }

  newPassword(username: string, pw: string, token: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Auth/ResetPassword`;
    return this.http.post<any>(url, { username, token, pw }, { withCredentials: true });
  }
  setTimeout() {
    var countDownDate = new Date();
    countDownDate.setHours(countDownDate.getHours() + 1);
    var countDownDate2 = new Date(countDownDate).getTime();
    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = countDownDate2 - now;
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      if (minutes == 0) {

      }
    }, 1000);
  }

  login(username: string, password: string) {
    var publicKey = "";
    if (publicKey == null) {
      publicKey = "";
    }
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    return this.http.post<any>(`${apiUrl}/Auth/authenticate`, { username, password, publicKey }, { withCredentials: true })
      .pipe(map(token => {
        const access_token = token.access_token;
        if (access_token != null) {
          this.currentUser = this.getDataFromToken(access_token);
          this.setTimeout();
          if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('user_token', token.access_token);
                  }
          this.Authenticated = true;
          this.currentUserSubject.next(this.currentUser);
          return "ok";
        } else {
          return "ko";
        }
      }));
  }
  loginWithCode(username: string, password: string, code: string) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    return this.http.post<any>(`${apiUrl}/Auth/authenticateWithCode`, { username, password, code }, { withCredentials: true })
      .pipe(map(token => {
        const access_token = token.access_token;
        this.currentUser = this.getDataFromToken(access_token);
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem('user_token', token.access_token);
        }
        this.Authenticated = true;
        this.currentUserSubject.next(this.currentUser);
        return this.currentUser;
      }));
  }
  logout() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('user_token');
    }
    this.Authenticated = false;
    this.currentUser = null;
    this.currentUserSubject.next(null);
  }

  private urlBase64Decode(str: string) {
    let output = str.replace('-', '+').replace('_', '/');
    switch (output.length % 4) {
      case 0:
        break;
      case 2:
        output += '==';
        break;
      case 3:
        output += '=';
        break;
      default:
        throw 'Illegal base64url string!';
    }
    if (isPlatformBrowser(this.platformId)) {
        return decodeURIComponent(escape(window.atob(output)));
    }else{
      return "";
    }
  }
  public GetToken(): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('user_token');
    }
  }
  private getDataFromToken(token: any) {
    let data = {};
    if (typeof token !== 'undefined') {
      const encoded = token.split('.')[1];
      data = JSON.parse(this.urlBase64Decode(encoded));
    }
    return data;
  }
}